import { Button } from 'components';
import styled from 'styled-components';
import { $Label } from 'styles';
import { fadeUp } from 'styles/components/Section';

export const $ImageWrapper = styled.div`
  background: #fcfcfd;
  width: 30%;
  margin-left: 35%;
  margin-right: 35%;
  border-radius: 50%;
  border-width: 1px;
  height: 200px;
  padding: 0;
  margin-bottom: 0px;
  margin-top: 10%;

  @media (max-width: 767px) {
    height: 150px;
    width: 150px;
    margin-left: 30%;
    margin-right: 30%;
  }
`;

export const $Image = styled.img`
  height: 200px;
  margin-left: 5%;
  margin-right: 3%;

  @media (max-width: 767px) {
    height: 150px;
    width: 150px;
    margin: 0;
  }
`;

export const $InputsWrapper = styled.div`
  position: relative;
  width: 50px;
  flex: 1;
  justify-content: center;

  & > * {
    @media (max-width: 1140px) {
      width: 80%;
      margin: 0 auto;
    }
  }
`;

export const $LabelWrapper = styled.div`
  flex: 0 0 100%;
  font-size: 25px;
  width: 350px;
  align-items: center;
  padding: 10px;
  text-align: center;
  flex-direction: row;

  ${props =>
    props.lang === 'ar' &&
    `
    @media (max-width: 1140px) {
    width: 80%;
  }
    `}
`;

export const $FormLabel = styled($Label)`
  text-align: center;
  text-wrap: wrap;
  font-family: Inter;
  font-size: 24px;
  font-weight: 500;
  line-height: 30px;
  letter-spacing: -0.10000000149011612px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;

export const $FormWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 5%;
`;

export const $Button = styled(Button)`
  background-color: #1c2024;
  padding: 12px;
  color: white;
  margin-top: -20%;
  margin-bottom: 2%;
  width: 100%;

  ${props =>
    props.styledProps.language === 'ar' &&
    `
      margin-top: -10%;
    `}

  &:hover {
    background-color: #1c2024;
  }

  @media (max-width: 1140px) {
    width: 80%;
    margin-right: 5%;
    margin-left: 5%;
  }
`;

export const $ErrorText = styled.div`
  color: red;
  font-size: ${({ theme }) => theme.font.size.label.md};
  margin: 0;
  position: absolute;
  margin-top: 5%;
  text-wrap: wrap;
  width: 50%;

  @media (max-width: 1024px) {
    margin: 6% 10% 0% 10%;
  }

  animation: ${fadeUp} 0.5s 0.2s backwards cubic-bezier(0.2, 0.8, 0.2, 1);
`;
